import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import CompanyDetail from './pages/CompanyDetail';
import ContactDetail from './pages/ContactDetail';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import Prospection from './pages/Prospection';
import { CampaignList, CampaignDetail } from './pages/Campaigns';
import { UserProvider } from '@/context/UserContext';
import { Toaster } from '@/components/ui/sonner';
import Footer from '@/components/Footer';
import '@/App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <UserProvider>
          <div className="flex-1">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/companies/:id" element={<PrivateRoute><CompanyDetail /></PrivateRoute>} />
              <Route path="/contacts/:id" element={<PrivateRoute><ContactDetail /></PrivateRoute>} />
              <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
              <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
              <Route path="/prospection" element={<PrivateRoute><Prospection /></PrivateRoute>} />
              <Route path="/campaigns" element={<PrivateRoute><CampaignList /></PrivateRoute>} />
              <Route path="/campaigns/:id" element={<PrivateRoute><CampaignDetail /></PrivateRoute>} />
            </Routes>
          </div>
          <Footer />
        </UserProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
